import axios from 'axios'
import normalizeDataForServer from 'utils/normalizeDataForServer'
import { setLocale, getLocale } from 'utils/localstorage'
import { store } from '../redux/store'
import { refreshAccessToken } from './refreshToken'
import { LOGIN_ROUTE, WRONG_PERMISSION_ROUTE } from 'constants/routes'

const REQUEST_METHOD_TO_AXIOS_METHOD = {
  POST: axios.post,
}

const checkResponse = (response) => {
  return Promise.resolve().then(() => {
    if (
      response.status === 401 &&
      window.location.pathname.indexOf('/login') < 0
    ) {
      const locale = getLocale()
      localStorage.clear()
      setLocale(locale)
      window.location.href = LOGIN_ROUTE
    }

    if (response.status === 403) {
      window.location.href = WRONG_PERMISSION_ROUTE
    }
    // TODO: return shown no match or change it
    // if (response.status === 404 || response.status === 500) {
    //   window.location.href = NO_MATCH_ROUTE
    // }

    if (!(response.status === 200 || response.status === 201)) {
      throw response.data
    }

    return response.data
  })
}

const uploadWithProgress = (
  endPoint,
  headers,
  method,
  data,
  cancelToken,
  onProgress
) => {
  const axiosMethod = REQUEST_METHOD_TO_AXIOS_METHOD[method]

  if (!axiosMethod) {
    return Promise.reject('error') // eslint-disable-line
  }

  return axiosMethod(endPoint, data, {
    headers,
    onUploadProgress: onProgress,
    cancelToken,
  })
    .then(checkResponse)
    .catch((error) => {
      throw error.response?.data
    })
}

const request = async (path, method, data, cancelToken, onProgress) => {
  const endPoint = window.REACT_APP_API_ENDPOINT + path
  const { token, refresh_token: refreshToken } = store.getState().auth

  const hasRefreshToken = !!refreshToken

  const headers = {
    Authorization: `Bearer ${token}`,
    Accept: 'application/json',
  }

  const makeFetch = () => {
    if (onProgress) {
      return uploadWithProgress(
        endPoint,
        headers,
        method,
        data,
        cancelToken,
        onProgress
      )
    }

    return fetch(endPoint, {
      headers,
      method,
      body: data,
    })
  }

  let response = await makeFetch()

  if (hasRefreshToken && response.status === 401) {
    const newToken = await refreshAccessToken()
    if (!newToken) {
      const locale = getLocale()
      localStorage.clear()
      setLocale(locale)
      window.location.href = LOGIN_ROUTE

      return
    }

    headers.Authorization = `Bearer ${newToken}`
    response = await makeFetch()
  }

  // Return an empty object for 204 No Content responses since there's nothing to parse
  if (response.status === 204) {
    return {}
  }

  if (onProgress) {
    return response
  }

  const json = await response.json()

  return checkResponse({ status: response.status, data: json })
}

const createFormData = (data) => {
  const formData = new FormData()
  Object.entries(normalizeDataForServer(data)).forEach(([key, value]) => {
    formData.append(key, value !== null ? value : '')
  })

  return formData
}

export const getRequest = (path) => request(path, 'GET')

export const postRequest = (path, data = {}, cancelToken, onProgress) =>
  request(path, 'POST', createFormData(data), cancelToken, onProgress)

export const putRequest = (path, data = {}) =>
  request(path, 'POST', createFormData({ _method: 'put', ...data }))

export const deleteRequest = (path) => request(path, 'DELETE')

export const patchRequest = (path, data = {}) =>
  request(path, 'POST', createFormData({ _method: 'patch', ...data }))
